// removed by extract-text-webpack-plugin
module.exports = {"Icon":"Icon__Icon__38Epv","MenuIcon":"Icon__MenuIcon__215Ki","CloudIcon":"Icon__CloudIcon__2ZLXc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/Icon.css
// module id = 80
// module chunks = 0